import { z } from 'zod';

// ─── Real-time per-site board ─────────────────────────────────────────────────
// Per worksite RIGHT NOW: who is on-site, since when. Response: { data: LiveWorksiteRow[] }.
export const LiveWorksiteWorkerSchema = z.object({
  employeeId: z.string(),
  name: z.string(),
  code: z.string(),
  checkedInAt: z.string(), // ISO datetime of the open SITE_IN
  onSiteMinutes: z.number().int(), // now - checkedInAt
  /**
   * MISSING CHECK-OUTS ONLY (null on a worker who is on site now): the time a
   * forced check-out starts from — the end of the shift the worker was
   * scheduled on the day they checked in (`AttendanceDay.scheduledEnd`), or,
   * with no shift, a standard day after the check-in. `suggestedFrom` says
   * which, so the screen never passes a guess off as the roster.
   */
  suggestedCheckoutAt: z.string().nullable().optional(),
  suggestedFrom: z.enum(['shift', 'standardDay']).nullable().optional(),
});
export type LiveWorksiteWorker = z.infer<typeof LiveWorksiteWorkerSchema>;

export const LiveWorksiteRowSchema = z.object({
  worksiteId: z.string(),
  worksiteName: z.string(),
  worksiteCode: z.string().nullable(),
  headcount: z.number().int(),
  capacity: z.number().int().nullable(),
  workers: z.array(LiveWorksiteWorkerSchema), // checked in under 16h ago: `headcount` counts these
  missingCheckout: z.array(LiveWorksiteWorkerSchema), // open 16h+: NOT in headcount (punchState.isStaleOpen)
  flagLongStay: z.boolean(), // any worker on-site > 12h (720 min)
  flagOverCapacity: z.boolean(), // capacity != null && headcount > capacity
  // Where the site IS, so the board can render map-first. Coordinates come from
  // the Worksite record (Decimal in the DB, plain number here); a site whose
  // lat/lng was never set is null and simply is not pinned — 0 is a legitimate
  // coordinate and must never be conflated with "unset".
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  city: z.string().nullable(),
  emirate: z.string().nullable(),
});
export type LiveWorksiteRow = z.infer<typeof LiveWorksiteRowSchema>;
